import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContentViewer } from "./courseStateSliceData.ts";

type ContentItemState = {
  chapter: Chapter;
};

interface Chapter {
  chapterId: string;
  moduleId: string;
}

const INIT_STATE: Record<string, ContentItemState> = {};

const CourseStateSlice = createSlice({
  name: "CourseStateSlice",
  initialState: INIT_STATE,
  reducers: {
    setChapter(state, action: PayloadAction<Chapter>) {
      const { chapterId, moduleId } = action.payload;
      return {
        ...state,
        chapter: { ...state.chapter, chapterId: chapterId, moduleId: moduleId }
      };
    }
  }
});

export default CourseStateSlice;

export const CourseStateSliceActions = CourseStateSlice.actions;
